import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';
import SweetAlert2 from 'sweetalert2';

import { ThirdPartyService } from '@ruby/core/http/third-party/third-party.service';
import { IThirdPartyEid, IThirdPartySearchCompany } from '@ruby/modules/third-party/models/third-party.interface';
import * as ThirdPartyCompaniesActions from '@ruby/modules/third-party/store/actions/third-party-companies.actions';
import { IError } from '@ruby/shared/models/request/error.interface';

@Injectable()
export class ThirdPartyCompaniesEffects {
  getCompanies$ = createEffect(() => this.actions$.pipe(
    ofType(ThirdPartyCompaniesActions.searchCompanies),
    exhaustMap(action => this.thirdPartySvc.getCompanies(action.data).pipe(
      map((companies: Array<IThirdPartySearchCompany>) => ThirdPartyCompaniesActions.searchCompaniesSuccess({ data: companies })),
      catchError((error: IError) => of(ThirdPartyCompaniesActions.searchCompaniesFailure({ error })))
    ))
  ));

  requestEid$ = createEffect(() => this.actions$.pipe(
    ofType(ThirdPartyCompaniesActions.requestEid),
    exhaustMap(action => this.thirdPartySvc.requestEid(action.data).pipe(
      map((response: IThirdPartyEid) => ThirdPartyCompaniesActions.requestEidSuccess()),
      catchError((error: IError) => of(ThirdPartyCompaniesActions.requestEidFailure({ error })))
    ))
  ));

  openDialog$ = createEffect(() => this.actions$.pipe(
      ofType(ThirdPartyCompaniesActions.requestEidSuccess),
      tap(() => {
        SweetAlert2.fire({
          title: 'Request has been submitted!',
          confirmButtonText: 'OK',
          icon: 'info',
          heightAuto: false
        });
      })),
    { dispatch: false }
  );

  constructor(private actions$: Actions, private thirdPartySvc: ThirdPartyService) {}
}
